// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessconflict/v1/accessviolation.proto" (package "c1.api.accessconflict.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Facets } from "../../search/v1/facet";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationExpandMask
 */
export interface AccessViolationExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationAuditExpandMask
 */
export interface AccessViolationAuditExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationListRequest
 */
export interface AccessViolationListRequest {
    /**
     * @generated from protobuf field: string conflict_monitor_id = 1
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask = 4
     */
    expandMask?: AccessViolationExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationView
 */
export interface AccessViolationView {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolation access_violation = 1
     */
    accessViolation?: AccessViolation;
    /**
     * @generated from protobuf field: string identity_user_path = 2
     */
    identityUserPath: string;
    /**
     * @generated from protobuf field: string group_a_app_path = 3
     */
    groupAAppPath: string;
    /**
     * @generated from protobuf field: string group_a_app_entitlement_path = 4
     */
    groupAAppEntitlementPath: string;
    /**
     * @generated from protobuf field: string group_b_app_path = 5
     */
    groupBAppPath: string;
    /**
     * @generated from protobuf field: string group_b_app_entitlement_path = 6
     */
    groupBAppEntitlementPath: string;
    /**
     * @generated from protobuf field: string group_a_app_user_path = 7
     */
    groupAAppUserPath: string;
    /**
     * @generated from protobuf field: string group_b_app_user_path = 8
     */
    groupBAppUserPath: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationListResponse
 */
export interface AccessViolationListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AccessViolationView list = 1
     */
    list: AccessViolationView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationUpdateStatusRequest
 */
export interface AccessViolationUpdateStatusRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 2
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: string reason = 3
     */
    reason: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask = 4
     */
    expandMask?: AccessViolationExpandMask;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.Status status = 5
     */
    status: Status;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationUpdateStatusResponse
 */
export interface AccessViolationUpdateStatusResponse {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationView view = 1
     */
    view?: AccessViolationView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolation
 */
export interface AccessViolation {
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 3
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: string identity_user_id = 4
     */
    identityUserId: string;
    /**
     * @generated from protobuf field: string group_a_app_id = 5
     */
    groupAAppId: string;
    /**
     * @generated from protobuf field: string group_a_app_entitlement_id = 6
     */
    groupAAppEntitlementId: string;
    /**
     * @generated from protobuf field: string group_b_app_id = 7
     */
    groupBAppId: string;
    /**
     * @generated from protobuf field: string group_b_app_entitlement_id = 8
     */
    groupBAppEntitlementId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 9
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 10
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 11
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.Status status = 12
     */
    status: Status;
    /**
     * @generated from protobuf field: string group_a_app_user_id = 13
     */
    groupAAppUserId: string;
    /**
     * @generated from protobuf field: string group_b_app_user_id = 14
     */
    groupBAppUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationAudit
 */
export interface AccessViolationAudit {
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 3
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: string access_violation_id = 4
     */
    accessViolationId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf oneof: typ
     */
    typ: {
        oneofKind: "created";
        /**
         * @generated from protobuf field: c1.api.accessconflict.v1.ViolationAuditCreated created = 100
         */
        created: ViolationAuditCreated;
    } | {
        oneofKind: "exempted";
        /**
         * @generated from protobuf field: c1.api.accessconflict.v1.ViolationAuditExempted exempted = 101
         */
        exempted: ViolationAuditExempted;
    } | {
        oneofKind: "exemptionRemoved";
        /**
         * @generated from protobuf field: c1.api.accessconflict.v1.ViolationAuditExemptionRemoved exemption_removed = 102
         */
        exemptionRemoved: ViolationAuditExemptionRemoved;
    } | {
        oneofKind: "resolved";
        /**
         * @generated from protobuf field: c1.api.accessconflict.v1.ViolationAuditResolved resolved = 103
         */
        resolved: ViolationAuditResolved;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationAuditView
 */
export interface AccessViolationAuditView {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationAudit access_violation_audit = 1
     */
    accessViolationAudit?: AccessViolationAudit;
    /**
     * @generated from protobuf field: string identity_user_path = 2
     */
    identityUserPath: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ViolationAuditCreated
 */
export interface ViolationAuditCreated {
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ViolationAuditExempted
 */
export interface ViolationAuditExempted {
    /**
     * @generated from protobuf field: string reason = 1
     */
    reason: string;
    /**
     * @generated from protobuf field: string updated_by = 2
     */
    updatedBy: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ViolationAuditExemptionRemoved
 */
export interface ViolationAuditExemptionRemoved {
    /**
     * @generated from protobuf field: string reason = 1
     */
    reason: string;
    /**
     * @generated from protobuf field: string updated_by = 2
     */
    updatedBy: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ViolationAuditResolved
 */
export interface ViolationAuditResolved {
    /**
     * @generated from protobuf field: string reason = 1
     */
    reason: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationAuditListRequest
 */
export interface AccessViolationAuditListRequest {
    /**
     * @generated from protobuf field: string conflict_monitor_id = 1
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: string access_violation_id = 2
     */
    accessViolationId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationAuditExpandMask expand_mask = 5
     */
    expandMask?: AccessViolationAuditExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationAuditListResponse
 */
export interface AccessViolationAuditListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AccessViolationAuditView list = 1
     */
    list: AccessViolationAuditView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationRef
 */
export interface AccessViolationRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 2
     */
    conflictMonitorId: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationCountRefreshRef
 */
export interface AccessViolationCountRefreshRef {
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationSearchRequest
 */
export interface AccessViolationSearchRequest {
    /**
     * @generated from protobuf field: string conflict_monitor_id = 1
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.Status access_violation_status = 2
     */
    accessViolationStatus: Status[];
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_entitlement_ids = 4
     */
    appEntitlementIds: string[];
    /**
     * @generated from protobuf field: repeated string identity_user_ids = 5
     */
    identityUserIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AccessViolationRef refs = 6
     */
    refs: AccessViolationRef[];
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask = 7
     */
    expandMask?: AccessViolationExpandMask;
    /**
     * @generated from protobuf field: int32 page_size = 8
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 9
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationSearchResponse
 */
export interface AccessViolationSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AccessViolationView list = 1
     */
    list: AccessViolationView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest
 */
export interface AccessViolationGetSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationSearchRequest search = 1
     */
    search?: AccessViolationSearchRequest;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest.TermType term = 2
     */
    term: AccessViolationGetSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest.TermType
 */
export enum AccessViolationGetSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_IDS = 1;
     */
    APP_ENTITLEMENT_IDS = 1,
    /**
     * @generated from protobuf enum value: IDENTITY_USER_IDS = 2;
     */
    IDENTITY_USER_IDS = 2
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AccessViolationGetSearchTermsResponse
 */
export interface AccessViolationGetSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1
     */
    facets?: Facets;
}
/**
 * @generated from protobuf enum c1.api.accessconflict.v1.Status
 */
export enum Status {
    /**
     * @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STATUS_ACTIVE = 1;
     */
    ACTIVE = 1,
    /**
     * @generated from protobuf enum value: STATUS_EXEMPTED = 2;
     */
    EXEMPTED = 2,
    /**
     * @generated from protobuf enum value: STATUS_RESOLVED = 3;
     */
    RESOLVED = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationExpandMask$Type extends MessageType<AccessViolationExpandMask> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "identity_user_id", "group_a_app_id", "group_a_app_entitlement_id", "group_b_app_id", "group_b_app_entitlement_id", "group_a_app_user_id", "group_b_app_user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessViolationExpandMask>): AccessViolationExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AccessViolationExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationExpandMask): AccessViolationExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationExpandMask
 */
export const AccessViolationExpandMask = new AccessViolationExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationAuditExpandMask$Type extends MessageType<AccessViolationAuditExpandMask> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationAuditExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "identity_user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessViolationAuditExpandMask>): AccessViolationAuditExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AccessViolationAuditExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationAuditExpandMask): AccessViolationAuditExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationAuditExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationAuditExpandMask
 */
export const AccessViolationAuditExpandMask = new AccessViolationAuditExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationListRequest$Type extends MessageType<AccessViolationListRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationListRequest", [
            { no: 1, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessViolationExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessViolationListRequest>): AccessViolationListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conflictMonitorId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessViolationListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationListRequest): AccessViolationListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conflict_monitor_id */ 1:
                    message.conflictMonitorId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask */ 4:
                    message.expandMask = AccessViolationExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conflict_monitor_id = 1; */
        if (message.conflictMonitorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conflictMonitorId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask = 4; */
        if (message.expandMask)
            AccessViolationExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationListRequest
 */
export const AccessViolationListRequest = new AccessViolationListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationView$Type extends MessageType<AccessViolationView> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationView", [
            { no: 1, name: "access_violation", kind: "message", T: () => AccessViolation },
            { no: 2, name: "identity_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "group_a_app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "group_a_app_entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "group_b_app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "group_b_app_entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "group_a_app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "group_b_app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessViolationView>): AccessViolationView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identityUserPath = "";
        message.groupAAppPath = "";
        message.groupAAppEntitlementPath = "";
        message.groupBAppPath = "";
        message.groupBAppEntitlementPath = "";
        message.groupAAppUserPath = "";
        message.groupBAppUserPath = "";
        if (value !== undefined)
            reflectionMergePartial<AccessViolationView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationView): AccessViolationView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessconflict.v1.AccessViolation access_violation */ 1:
                    message.accessViolation = AccessViolation.internalBinaryRead(reader, reader.uint32(), options, message.accessViolation);
                    break;
                case /* string identity_user_path */ 2:
                    message.identityUserPath = reader.string();
                    break;
                case /* string group_a_app_path */ 3:
                    message.groupAAppPath = reader.string();
                    break;
                case /* string group_a_app_entitlement_path */ 4:
                    message.groupAAppEntitlementPath = reader.string();
                    break;
                case /* string group_b_app_path */ 5:
                    message.groupBAppPath = reader.string();
                    break;
                case /* string group_b_app_entitlement_path */ 6:
                    message.groupBAppEntitlementPath = reader.string();
                    break;
                case /* string group_a_app_user_path */ 7:
                    message.groupAAppUserPath = reader.string();
                    break;
                case /* string group_b_app_user_path */ 8:
                    message.groupBAppUserPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessconflict.v1.AccessViolation access_violation = 1; */
        if (message.accessViolation)
            AccessViolation.internalBinaryWrite(message.accessViolation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identity_user_path = 2; */
        if (message.identityUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identityUserPath);
        /* string group_a_app_path = 3; */
        if (message.groupAAppPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.groupAAppPath);
        /* string group_a_app_entitlement_path = 4; */
        if (message.groupAAppEntitlementPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.groupAAppEntitlementPath);
        /* string group_b_app_path = 5; */
        if (message.groupBAppPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.groupBAppPath);
        /* string group_b_app_entitlement_path = 6; */
        if (message.groupBAppEntitlementPath !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.groupBAppEntitlementPath);
        /* string group_a_app_user_path = 7; */
        if (message.groupAAppUserPath !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.groupAAppUserPath);
        /* string group_b_app_user_path = 8; */
        if (message.groupBAppUserPath !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.groupBAppUserPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationView
 */
export const AccessViolationView = new AccessViolationView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationListResponse$Type extends MessageType<AccessViolationListResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessViolationView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessViolationListResponse>): AccessViolationListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessViolationListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationListResponse): AccessViolationListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessconflict.v1.AccessViolationView list */ 1:
                    message.list.push(AccessViolationView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessconflict.v1.AccessViolationView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessViolationView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationListResponse
 */
export const AccessViolationListResponse = new AccessViolationListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationUpdateStatusRequest$Type extends MessageType<AccessViolationUpdateStatusRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationUpdateStatusRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessViolationExpandMask },
            { no: 5, name: "status", kind: "enum", T: () => ["c1.api.accessconflict.v1.Status", Status, "STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<AccessViolationUpdateStatusRequest>): AccessViolationUpdateStatusRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.conflictMonitorId = "";
        message.reason = "";
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessViolationUpdateStatusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationUpdateStatusRequest): AccessViolationUpdateStatusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string conflict_monitor_id */ 2:
                    message.conflictMonitorId = reader.string();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask */ 4:
                    message.expandMask = AccessViolationExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* c1.api.accessconflict.v1.Status status */ 5:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationUpdateStatusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string conflict_monitor_id = 2; */
        if (message.conflictMonitorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.conflictMonitorId);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask = 4; */
        if (message.expandMask)
            AccessViolationExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessconflict.v1.Status status = 5; */
        if (message.status !== 0)
            writer.tag(5, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationUpdateStatusRequest
 */
export const AccessViolationUpdateStatusRequest = new AccessViolationUpdateStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationUpdateStatusResponse$Type extends MessageType<AccessViolationUpdateStatusResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationUpdateStatusResponse", [
            { no: 1, name: "view", kind: "message", T: () => AccessViolationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessViolationUpdateStatusResponse>): AccessViolationUpdateStatusResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessViolationUpdateStatusResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationUpdateStatusResponse): AccessViolationUpdateStatusResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessconflict.v1.AccessViolationView view */ 1:
                    message.view = AccessViolationView.internalBinaryRead(reader, reader.uint32(), options, message.view);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationUpdateStatusResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessconflict.v1.AccessViolationView view = 1; */
        if (message.view)
            AccessViolationView.internalBinaryWrite(message.view, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationUpdateStatusResponse
 */
export const AccessViolationUpdateStatusResponse = new AccessViolationUpdateStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolation$Type extends MessageType<AccessViolation> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolation", [
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "group_a_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "group_a_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 7, name: "group_b_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 8, name: "group_b_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 9, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 11, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "status", kind: "enum", T: () => ["c1.api.accessconflict.v1.Status", Status, "STATUS_"] },
            { no: 13, name: "group_a_app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 14, name: "group_b_app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessViolation>): AccessViolation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.conflictMonitorId = "";
        message.identityUserId = "";
        message.groupAAppId = "";
        message.groupAAppEntitlementId = "";
        message.groupBAppId = "";
        message.groupBAppEntitlementId = "";
        message.status = 0;
        message.groupAAppUserId = "";
        message.groupBAppUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessViolation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolation): AccessViolation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* string conflict_monitor_id */ 3:
                    message.conflictMonitorId = reader.string();
                    break;
                case /* string identity_user_id */ 4:
                    message.identityUserId = reader.string();
                    break;
                case /* string group_a_app_id */ 5:
                    message.groupAAppId = reader.string();
                    break;
                case /* string group_a_app_entitlement_id */ 6:
                    message.groupAAppEntitlementId = reader.string();
                    break;
                case /* string group_b_app_id */ 7:
                    message.groupBAppId = reader.string();
                    break;
                case /* string group_b_app_entitlement_id */ 8:
                    message.groupBAppEntitlementId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 9:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 10:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 11:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.accessconflict.v1.Status status */ 12:
                    message.status = reader.int32();
                    break;
                case /* string group_a_app_user_id */ 13:
                    message.groupAAppUserId = reader.string();
                    break;
                case /* string group_b_app_user_id */ 14:
                    message.groupBAppUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* string conflict_monitor_id = 3; */
        if (message.conflictMonitorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.conflictMonitorId);
        /* string identity_user_id = 4; */
        if (message.identityUserId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.identityUserId);
        /* string group_a_app_id = 5; */
        if (message.groupAAppId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.groupAAppId);
        /* string group_a_app_entitlement_id = 6; */
        if (message.groupAAppEntitlementId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.groupAAppEntitlementId);
        /* string group_b_app_id = 7; */
        if (message.groupBAppId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.groupBAppId);
        /* string group_b_app_entitlement_id = 8; */
        if (message.groupBAppEntitlementId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.groupBAppEntitlementId);
        /* google.protobuf.Timestamp created_at = 9; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 10; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 11; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessconflict.v1.Status status = 12; */
        if (message.status !== 0)
            writer.tag(12, WireType.Varint).int32(message.status);
        /* string group_a_app_user_id = 13; */
        if (message.groupAAppUserId !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.groupAAppUserId);
        /* string group_b_app_user_id = 14; */
        if (message.groupBAppUserId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.groupBAppUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolation
 */
export const AccessViolation = new AccessViolation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationAudit$Type extends MessageType<AccessViolationAudit> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationAudit", [
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "access_violation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 100, name: "created", kind: "message", oneof: "typ", T: () => ViolationAuditCreated },
            { no: 101, name: "exempted", kind: "message", oneof: "typ", T: () => ViolationAuditExempted },
            { no: 102, name: "exemption_removed", kind: "message", oneof: "typ", T: () => ViolationAuditExemptionRemoved },
            { no: 103, name: "resolved", kind: "message", oneof: "typ", T: () => ViolationAuditResolved }
        ]);
    }
    create(value?: PartialMessage<AccessViolationAudit>): AccessViolationAudit {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.conflictMonitorId = "";
        message.accessViolationId = "";
        message.typ = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AccessViolationAudit>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationAudit): AccessViolationAudit {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* string conflict_monitor_id */ 3:
                    message.conflictMonitorId = reader.string();
                    break;
                case /* string access_violation_id */ 4:
                    message.accessViolationId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.accessconflict.v1.ViolationAuditCreated created */ 100:
                    message.typ = {
                        oneofKind: "created",
                        created: ViolationAuditCreated.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).created)
                    };
                    break;
                case /* c1.api.accessconflict.v1.ViolationAuditExempted exempted */ 101:
                    message.typ = {
                        oneofKind: "exempted",
                        exempted: ViolationAuditExempted.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).exempted)
                    };
                    break;
                case /* c1.api.accessconflict.v1.ViolationAuditExemptionRemoved exemption_removed */ 102:
                    message.typ = {
                        oneofKind: "exemptionRemoved",
                        exemptionRemoved: ViolationAuditExemptionRemoved.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).exemptionRemoved)
                    };
                    break;
                case /* c1.api.accessconflict.v1.ViolationAuditResolved resolved */ 103:
                    message.typ = {
                        oneofKind: "resolved",
                        resolved: ViolationAuditResolved.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).resolved)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationAudit, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* string conflict_monitor_id = 3; */
        if (message.conflictMonitorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.conflictMonitorId);
        /* string access_violation_id = 4; */
        if (message.accessViolationId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.accessViolationId);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessconflict.v1.ViolationAuditCreated created = 100; */
        if (message.typ.oneofKind === "created")
            ViolationAuditCreated.internalBinaryWrite(message.typ.created, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessconflict.v1.ViolationAuditExempted exempted = 101; */
        if (message.typ.oneofKind === "exempted")
            ViolationAuditExempted.internalBinaryWrite(message.typ.exempted, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessconflict.v1.ViolationAuditExemptionRemoved exemption_removed = 102; */
        if (message.typ.oneofKind === "exemptionRemoved")
            ViolationAuditExemptionRemoved.internalBinaryWrite(message.typ.exemptionRemoved, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessconflict.v1.ViolationAuditResolved resolved = 103; */
        if (message.typ.oneofKind === "resolved")
            ViolationAuditResolved.internalBinaryWrite(message.typ.resolved, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationAudit
 */
export const AccessViolationAudit = new AccessViolationAudit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationAuditView$Type extends MessageType<AccessViolationAuditView> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationAuditView", [
            { no: 1, name: "access_violation_audit", kind: "message", T: () => AccessViolationAudit },
            { no: 2, name: "identity_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessViolationAuditView>): AccessViolationAuditView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identityUserPath = "";
        if (value !== undefined)
            reflectionMergePartial<AccessViolationAuditView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationAuditView): AccessViolationAuditView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessconflict.v1.AccessViolationAudit access_violation_audit */ 1:
                    message.accessViolationAudit = AccessViolationAudit.internalBinaryRead(reader, reader.uint32(), options, message.accessViolationAudit);
                    break;
                case /* string identity_user_path */ 2:
                    message.identityUserPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationAuditView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessconflict.v1.AccessViolationAudit access_violation_audit = 1; */
        if (message.accessViolationAudit)
            AccessViolationAudit.internalBinaryWrite(message.accessViolationAudit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identity_user_path = 2; */
        if (message.identityUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identityUserPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationAuditView
 */
export const AccessViolationAuditView = new AccessViolationAuditView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ViolationAuditCreated$Type extends MessageType<ViolationAuditCreated> {
    constructor() {
        super("c1.api.accessconflict.v1.ViolationAuditCreated", []);
    }
    create(value?: PartialMessage<ViolationAuditCreated>): ViolationAuditCreated {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ViolationAuditCreated>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ViolationAuditCreated): ViolationAuditCreated {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ViolationAuditCreated, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ViolationAuditCreated
 */
export const ViolationAuditCreated = new ViolationAuditCreated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ViolationAuditExempted$Type extends MessageType<ViolationAuditExempted> {
    constructor() {
        super("c1.api.accessconflict.v1.ViolationAuditExempted", [
            { no: 1, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "updated_by", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ViolationAuditExempted>): ViolationAuditExempted {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reason = "";
        message.updatedBy = "";
        if (value !== undefined)
            reflectionMergePartial<ViolationAuditExempted>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ViolationAuditExempted): ViolationAuditExempted {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string reason */ 1:
                    message.reason = reader.string();
                    break;
                case /* string updated_by */ 2:
                    message.updatedBy = reader.string();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ViolationAuditExempted, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string reason = 1; */
        if (message.reason !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.reason);
        /* string updated_by = 2; */
        if (message.updatedBy !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.updatedBy);
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ViolationAuditExempted
 */
export const ViolationAuditExempted = new ViolationAuditExempted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ViolationAuditExemptionRemoved$Type extends MessageType<ViolationAuditExemptionRemoved> {
    constructor() {
        super("c1.api.accessconflict.v1.ViolationAuditExemptionRemoved", [
            { no: 1, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "updated_by", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ViolationAuditExemptionRemoved>): ViolationAuditExemptionRemoved {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reason = "";
        message.updatedBy = "";
        if (value !== undefined)
            reflectionMergePartial<ViolationAuditExemptionRemoved>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ViolationAuditExemptionRemoved): ViolationAuditExemptionRemoved {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string reason */ 1:
                    message.reason = reader.string();
                    break;
                case /* string updated_by */ 2:
                    message.updatedBy = reader.string();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ViolationAuditExemptionRemoved, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string reason = 1; */
        if (message.reason !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.reason);
        /* string updated_by = 2; */
        if (message.updatedBy !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.updatedBy);
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ViolationAuditExemptionRemoved
 */
export const ViolationAuditExemptionRemoved = new ViolationAuditExemptionRemoved$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ViolationAuditResolved$Type extends MessageType<ViolationAuditResolved> {
    constructor() {
        super("c1.api.accessconflict.v1.ViolationAuditResolved", [
            { no: 1, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ViolationAuditResolved>): ViolationAuditResolved {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<ViolationAuditResolved>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ViolationAuditResolved): ViolationAuditResolved {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string reason */ 1:
                    message.reason = reader.string();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ViolationAuditResolved, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string reason = 1; */
        if (message.reason !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.reason);
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ViolationAuditResolved
 */
export const ViolationAuditResolved = new ViolationAuditResolved$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationAuditListRequest$Type extends MessageType<AccessViolationAuditListRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationAuditListRequest", [
            { no: 1, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "access_violation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessViolationAuditExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessViolationAuditListRequest>): AccessViolationAuditListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conflictMonitorId = "";
        message.accessViolationId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessViolationAuditListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationAuditListRequest): AccessViolationAuditListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conflict_monitor_id */ 1:
                    message.conflictMonitorId = reader.string();
                    break;
                case /* string access_violation_id */ 2:
                    message.accessViolationId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.AccessViolationAuditExpandMask expand_mask */ 5:
                    message.expandMask = AccessViolationAuditExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationAuditListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conflict_monitor_id = 1; */
        if (message.conflictMonitorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conflictMonitorId);
        /* string access_violation_id = 2; */
        if (message.accessViolationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessViolationId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessconflict.v1.AccessViolationAuditExpandMask expand_mask = 5; */
        if (message.expandMask)
            AccessViolationAuditExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationAuditListRequest
 */
export const AccessViolationAuditListRequest = new AccessViolationAuditListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationAuditListResponse$Type extends MessageType<AccessViolationAuditListResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationAuditListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessViolationAuditView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessViolationAuditListResponse>): AccessViolationAuditListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessViolationAuditListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationAuditListResponse): AccessViolationAuditListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessconflict.v1.AccessViolationAuditView list */ 1:
                    message.list.push(AccessViolationAuditView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationAuditListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessconflict.v1.AccessViolationAuditView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessViolationAuditView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationAuditListResponse
 */
export const AccessViolationAuditListResponse = new AccessViolationAuditListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationRef$Type extends MessageType<AccessViolationRef> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessViolationRef>): AccessViolationRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.conflictMonitorId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessViolationRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationRef): AccessViolationRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string conflict_monitor_id */ 2:
                    message.conflictMonitorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string conflict_monitor_id = 2; */
        if (message.conflictMonitorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.conflictMonitorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationRef
 */
export const AccessViolationRef = new AccessViolationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationCountRefreshRef$Type extends MessageType<AccessViolationCountRefreshRef> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationCountRefreshRef", []);
    }
    create(value?: PartialMessage<AccessViolationCountRefreshRef>): AccessViolationCountRefreshRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessViolationCountRefreshRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationCountRefreshRef): AccessViolationCountRefreshRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationCountRefreshRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationCountRefreshRef
 */
export const AccessViolationCountRefreshRef = new AccessViolationCountRefreshRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationSearchRequest$Type extends MessageType<AccessViolationSearchRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationSearchRequest", [
            { no: 1, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "access_violation_status", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessconflict.v1.Status", Status, "STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "identity_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessViolationRef },
            { no: 7, name: "expand_mask", kind: "message", T: () => AccessViolationExpandMask },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 9, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessViolationSearchRequest>): AccessViolationSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conflictMonitorId = "";
        message.accessViolationStatus = [];
        message.query = "";
        message.appEntitlementIds = [];
        message.identityUserIds = [];
        message.refs = [];
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessViolationSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationSearchRequest): AccessViolationSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conflict_monitor_id */ 1:
                    message.conflictMonitorId = reader.string();
                    break;
                case /* repeated c1.api.accessconflict.v1.Status access_violation_status */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accessViolationStatus.push(reader.int32());
                    else
                        message.accessViolationStatus.push(reader.int32());
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string app_entitlement_ids */ 4:
                    message.appEntitlementIds.push(reader.string());
                    break;
                case /* repeated string identity_user_ids */ 5:
                    message.identityUserIds.push(reader.string());
                    break;
                case /* repeated c1.api.accessconflict.v1.AccessViolationRef refs */ 6:
                    message.refs.push(AccessViolationRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask */ 7:
                    message.expandMask = AccessViolationExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* int32 page_size */ 8:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 9:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conflict_monitor_id = 1; */
        if (message.conflictMonitorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conflictMonitorId);
        /* repeated c1.api.accessconflict.v1.Status access_violation_status = 2; */
        if (message.accessViolationStatus.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accessViolationStatus.length; i++)
                writer.int32(message.accessViolationStatus[i]);
            writer.join();
        }
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string app_entitlement_ids = 4; */
        for (let i = 0; i < message.appEntitlementIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.appEntitlementIds[i]);
        /* repeated string identity_user_ids = 5; */
        for (let i = 0; i < message.identityUserIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.identityUserIds[i]);
        /* repeated c1.api.accessconflict.v1.AccessViolationRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AccessViolationRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessconflict.v1.AccessViolationExpandMask expand_mask = 7; */
        if (message.expandMask)
            AccessViolationExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int32 page_size = 8; */
        if (message.pageSize !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageSize);
        /* string page_token = 9; */
        if (message.pageToken !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationSearchRequest
 */
export const AccessViolationSearchRequest = new AccessViolationSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationSearchResponse$Type extends MessageType<AccessViolationSearchResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessViolationView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessViolationSearchResponse>): AccessViolationSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessViolationSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationSearchResponse): AccessViolationSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessconflict.v1.AccessViolationView list */ 1:
                    message.list.push(AccessViolationView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessconflict.v1.AccessViolationView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessViolationView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationSearchResponse
 */
export const AccessViolationSearchResponse = new AccessViolationSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationGetSearchTermsRequest$Type extends MessageType<AccessViolationGetSearchTermsRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => AccessViolationSearchRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest.TermType", AccessViolationGetSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AccessViolationGetSearchTermsRequest>): AccessViolationGetSearchTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.term = 0;
        message.query = "";
        message.includeCount = false;
        if (value !== undefined)
            reflectionMergePartial<AccessViolationGetSearchTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationGetSearchTermsRequest): AccessViolationGetSearchTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessconflict.v1.AccessViolationSearchRequest search */ 1:
                    message.search = AccessViolationSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.search);
                    break;
                case /* c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest.TermType term */ 2:
                    message.term = reader.int32();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* bool include_count */ 4:
                    message.includeCount = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationGetSearchTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessconflict.v1.AccessViolationSearchRequest search = 1; */
        if (message.search)
            AccessViolationSearchRequest.internalBinaryWrite(message.search, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest.TermType term = 2; */
        if (message.term !== 0)
            writer.tag(2, WireType.Varint).int32(message.term);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* bool include_count = 4; */
        if (message.includeCount !== false)
            writer.tag(4, WireType.Varint).bool(message.includeCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationGetSearchTermsRequest
 */
export const AccessViolationGetSearchTermsRequest = new AccessViolationGetSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessViolationGetSearchTermsResponse$Type extends MessageType<AccessViolationGetSearchTermsResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.AccessViolationGetSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
    create(value?: PartialMessage<AccessViolationGetSearchTermsResponse>): AccessViolationGetSearchTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessViolationGetSearchTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessViolationGetSearchTermsResponse): AccessViolationGetSearchTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.search.v1.Facets facets */ 1:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessViolationGetSearchTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.search.v1.Facets facets = 1; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AccessViolationGetSearchTermsResponse
 */
export const AccessViolationGetSearchTermsResponse = new AccessViolationGetSearchTermsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AccessViolationService
 */
export const AccessViolationService = new ServiceType("c1.api.accessconflict.v1.AccessViolationService", [
    { name: "ListAccessViolation", options: { "authz.method": { role: "VIEWER" } }, I: AccessViolationListRequest, O: AccessViolationListResponse },
    { name: "UpdateAccessViolationStatus", options: { "authz.method": { role: "EDITOR" } }, I: AccessViolationUpdateStatusRequest, O: AccessViolationUpdateStatusResponse },
    { name: "ListAccessViolationAudit", options: { "authz.method": { role: "VIEWER" } }, I: AccessViolationAuditListRequest, O: AccessViolationAuditListResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AccessViolationSearch
 */
export const AccessViolationSearch = new ServiceType("c1.api.accessconflict.v1.AccessViolationSearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AccessViolationSearchRequest, O: AccessViolationSearchResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: AccessViolationGetSearchTermsRequest, O: AccessViolationGetSearchTermsResponse }
]);
